import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';

import { LoadingButton } from '~components/atoms/custom';
import { useAuth } from '~providers';

export const AccessDeniedPage: React.FC = () => {
  const { signOut } = useAuth();
  const [isSigningOut, setIsSigningOut] = useState(false);

  // Clear user credentials before returning to login.
  const handleReturnToLogin = () => {
    setIsSigningOut(true);
    signOut();
    setIsSigningOut(false);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        minHeight: 'calc(100dvh - 64px)',
        backgroundColor: 'white',
        width: '100%',
        p: 2,
      }}
    >
      <Typography
        variant="h1"
        sx={{
          color: (theme) => theme.palette.neutral[900],
          marginBottom: 2,
        }}
      >
        403
      </Typography>
      <Typography
        variant="h6"
        textAlign="center"
        sx={{
          color: (theme) => theme.palette.neutral[600],
          marginBottom: 3,
        }}
      >
        You don't have permission to access this page.
      </Typography>
      <LoadingButton
        fullWidth={false}
        isLoading={isSigningOut}
        onClick={handleReturnToLogin}
      >
        <Typography variant="body2" fontWeight={500}>
          Return to login
        </Typography>
      </LoadingButton>
    </Box>
  );
};
